// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const sin: CountryValidator<"CA"> = createValidator(
  "ca.sin",
  31,
);

export default sin;
export const compact = sin.compact;
export const format = sin.format;
export const validate = sin.validate;
export const generate = (): string =>
  sin.generate?.() ??
  (() => {
    throw new Error(
      "Validator ca.sin cannot generate values",
    );
  })();
